import { g, ui } from '@clientio/jointjs';

/**
 * Class representing a highlighter frame list for selection.
 * Extends the `ui.HighlighterSelectionFrameList` class.
 */
export class HighlighterFrameList extends ui.HighlighterSelectionFrameList {
  constructor(options = {}) {
    super(options);
  }

  /**
   * Gets the bounding box that encompasses all selected elements.
   * Prevent including link boundary boxes in selection wrapper bbox.
   * @returns {g.Rect} The bounding box that encompasses all selected elements.
   */
  getBBox() {
    const elementBBoxes = [];

    this.selection.collection.models
      .filter((m) => m.isElement())
      .forEach((m) => {
        const cellBBox = this.getCellBBox(m);
        if (cellBBox) {
          elementBBoxes.push(cellBBox);
        }
      });

    return g.Rect.fromRectUnion(...elementBBoxes);
  }
}
